import { Currency } from "@models/clients/currency";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

class CurrencyController {
  public currency: Currency;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;
  public currencyForm: angular.IFormController;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientCRMRepo: ClientCRMRepo
  ) {}

  $onInit() {
    // Initialize currency object - create a copy to avoid modifying the original
    if (this.currency) {
      this.currency = { ...this.currency }; // Create a shallow copy
      this.isEditMode = this.currency.id > 0;
    } else {
      this.currency = { 
        id: 0, 
        name: '', 
        symbol: '', 
        code: '', 
        exchangeRate: 0 
      };
      this.isEditMode = false;
    }
  }

  public saveCurrency() {
    // Trigger form validation
    this.currencyForm.$setSubmitted();
    
    // Check if form is valid
    if (this.currencyForm.$invalid) {
      return;
    }

    this.isLoading = true;
    
    // Call the single saveCurrency endpoint - backend will determine if it's create or update based on the ID
    this.clientCRMRepo.saveCurrency(this.currency)
      .then((result) => {
        this.$mdDialog.hide(this.currency);
      })
      .catch((error) => {
        console.error('Error saving currency:', error);
        // You could add error handling/notification here
        this.isLoading = false;
      });
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const currencyModal: angular.IComponentOptions = {
  template: require("./currency.html"),
  controller: CurrencyController,
  bindings: {
    currency: "<?"
  }
};



// WEBPACK FOOTER //
// ./src/app/clientmanagement/modals/currency.ts